import request from "./request";

const api = {
  getUserWalletLogList: "user_wallet_log/getUserWalletLogList",
};
export default {
  getUserWalletLogList(parameter) {
    return request({
      url: api.getUserWalletLogList,
      method: "POST",
      data: parameter,
    });
  },
};
